import { Box } from '@mui/material';
import LoadingOverlay from './loadingOverlay';

type DataGridWrapperProps = {
  loading: boolean;
  children: JSX.Element;
};

const DataGridWrapper = (props: DataGridWrapperProps) => {
  const { loading, children } = props;
  return (
    <Box
      sx={{
        position: 'relative',
        '.MuiDataGrid-root': { border: 'none' },
      }}
    >
      <LoadingOverlay loading={loading} />
      {children}
    </Box>
  );
};

export default DataGridWrapper;
